import { EventEmitter as OriginalEventEmitter } from 'events';

// пришлось определить самому, потому что ts ругается, что в events не экспортируется такой тип
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Listener = (...args: any[]) => void;

export class EventEmitter extends OriginalEventEmitter {
    /**
     * Запускает операцию по типу события, когда на него появляются подписчики
     *
     * @param type
     */
    public startJob?(type: string): void;

    /**
     * Останавливает операцию по типу события, когда у него исчезают подписчики
     *
     * @param type
     */
    public stopJob?(type?: string): void;

    public addEventListener = (type: string, listener: Listener) => {
        this._startForListeners(type);
        return super.addListener(type, listener);
    };

    public on(type: string, listener: Listener): this {
        this._startForListeners(type);
        return super.on(type, listener);
    }

    private _stopIfNoListeners(type: string) {
        if (this._getIsNoListeners(type) && this.stopJob) {
            this.stopJob(type);
        }
    }

    public removeEventListener = (type: string, listener: Listener) => {
        const self = super.removeListener(type, listener);
        this._stopIfNoListeners(type);

        return self;
    };

    public off(type: string, listener: Listener): this {
        const self = super.off(type, listener);
        this._stopIfNoListeners(type);

        return self;
    }

    public removeAllListeners(type?: string): this {
        const self = super.removeAllListeners(type);
        if (type) {
            this._stopIfNoListeners(type);
        } else if (this.stopJob) {
            this.stopJob();
        }
        return self;
    }

    private _getIsNoListeners(type: string) {
        return this.listenerCount(type) === 0;
    }
    private _startForListeners(type: string) {
        if (this._getIsNoListeners(type) && this.startJob) {
            this.startJob(type);
        }
    }
}
